import FlooringTableFilter from "./flooring-table-filter";
import FlooringVariationTableFilter from "./flooring-variation-table-filter";

const FlooringFilters = {
  Table: FlooringTableFilter,
  VariationTable: FlooringVariationTableFilter,
};

export default FlooringFilters;
